import React from 'react'
import {connect} from "react-redux";
import Acc from "./Acc";
import Windowbutton from "../../../gui/windowbutton";

import c from '../../../etc/Const'
import {backgroundColor} from "./style";

const AccBox = ({acc_nodes, id}) => {

    let xx = []
    for (let k of Object.keys(acc_nodes)) {
        xx.push(<Acc key={acc_nodes[k].uid} nodeid={acc_nodes[k].uid} header={true}/>)
    }

    const _width = 11 * c.p1
    const _height = window.innerHeight*2/3

    return (
        <Windowbutton close={() => {
        }} headline={'Accessories'} id={'ACC'} width={_width} icon={'AC'}>
            <div style={{
                background: backgroundColor,
                border: '1px, solid, black',
                display: 'inline',
                position: 'absolute',
                maxHeight: _height,
                width: _width,
                overflow: 'auto',
            }}>
                {xx}
            </div>
        </Windowbutton>
    )
}

function mapStateToProps(state, other) {
    var itms_acc = state.bidib.data.node.filter((itm) => {
        return itm.FEATURE_ACCESSORY_COUNT > 0
    });
    return {acc_nodes: itms_acc};
}

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(AccBox)